/**
 * Before launch (VITE_COMING_SOON=1, set only for the production deploy in
 * .github/workflows/deploy.yml): the landing page is public and indexable,
 * but every call to action joins the waitlist (040) instead of creating an
 * account. The pricing is shown just as openly as after launch (decided
 * 2026-10-15): the plans, the amounts and every term of the founding offer.
 *
 * Sign-in stays open for the people who already belong: the installed app
 * (the family's home-screen icon), the watch's pairing QR (/?pair) and the
 * landing's "Sign in" (/?signin) get the sign-in form, without Create
 * account. Signed-in sessions are never affected. Launch = drop the env line,
 * and the same page sells instead (pricing back, Create account back).
 */
export const PRELAUNCH = import.meta.env.VITE_COMING_SOON === '1'

/** What a signed-out visitor sees. */
export type SignedOutView = 'landing' | 'waitlist' | 'form'

export function signedOutView(opts: {
  prelaunch?: boolean
  standalone: boolean
  pairIntent: boolean
  /** ?signin: the landing's Sign in before launch. */
  signinLink: boolean
}): SignedOutView {
  const { prelaunch = PRELAUNCH, standalone, pairIntent, signinLink } = opts
  if (standalone || pairIntent || (prelaunch && signinLink)) return 'form'
  return prelaunch ? 'waitlist' : 'landing'
}
